import { Helmet } from "react-helmet-async";

import AboutContent from "../components/AboutContent";
import AboutHero from "../components/AboutHero";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar"










export default function AboutPage() {
  return (
    <>
  


      <Navbar />
      <AboutHero />
      <AboutContent />
      <Footer />

    </>
  );
}